BatchGeoStore.addReducer(
  "RowSelect",
  {
    selection: [],
    options: {},
    previousSelection: [],
    selectedFromDrawing: false,
  },
  {
    // When a SELECT happens we just want to start a new state with the selected
    // rows not add or remove any specific rows
    ROW_SELECT_SELECT: function (state, action) {
      return Object.assign({}, state, {
        selection: action.selectedRows,
        options: action.options || {},
        selectedFromDrawing: action.selectedFromDrawing ? true : false,
      });
    },
    // When a SELECTADD happens we need to take the existing selection and
    // combine (concat) it with the new selection then filter out the dupes. We
    // can filter out the dupes with the native filter function.
    ROW_SELECT_SELECTADD: function (state, action) {
      var selection = state.selection;
      var mergedRows = selection.concat(action.selectedRows);
      return Object.assign({}, state, {
        selection: mergedRows.filter(function (el, index, self) {
          return index == self.indexOf(el);
        }),
        options: action.options || {},
        previousSelection: state.selection,
        selectedFromDrawing: action.selectedFromDrawing ? true : false,
      });
    },
    // When a DESELECT happens we take the new selection and filter the current
    // selection looking for matches. If it's a match we need to remove it so we
    // need to return a falsey value (i.e. if the row ID's index is 2, 2>-1) so
    // it'll return false which will remove it from the selection
    ROW_SELECT_DESELECT: function (state, action) {
      return Object.assign({}, state, {
        selection: state.selection.filter(function (el) {
          return action.selectedRows.indexOf(el) < 0;
        }),
        options: action.options || {},
        previousSelection: state.selection,
        selectedFromDrawing: action.selectedFromDrawing ? true : false,
      });
    },
    // When a DESELECTALL happens we simply give the state an empty selection
    ROW_SELECT_DESELECTALL: function (state, action) {
      return Object.assign({}, state, {
        selection: [],
        options: action.options || {},
        previousSelection: state.selection,
        selectedFromDrawing: action.selectedFromDrawing ? true : false,
      });
    },
  },
);
